import { render } from "./product_owner.vue?vue&type=template&id=0c52248a&scoped=true"
import script from "./product_owner.vue?vue&type=script&lang=js"
export * from "./product_owner.vue?vue&type=script&lang=js"

import "./product_owner.vue?vue&type=style&index=0&id=0c52248a&scoped=true&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c52248a"]])

export default __exports__